export var DocsBlockOptionRenderingStyle;
(function (DocsBlockOptionRenderingStyle) {
    /** Option will be rendered as a segmented control */
    DocsBlockOptionRenderingStyle["segmentedControl"] = "SegmentedControl";
    /** Option will be rendered as a toggle button */
    DocsBlockOptionRenderingStyle["toggleButton"] = "ToggleButton";
    /** Option will be rendered as a select */
    DocsBlockOptionRenderingStyle["select"] = "Select";
    /** Option will be rendered as checkboxes/radios */
    DocsBlockOptionRenderingStyle["checkbox"] = "Checkbox";
})(DocsBlockOptionRenderingStyle || (DocsBlockOptionRenderingStyle = {}));
